import type { Folder } from '@/util/Types/Folder';

export const MAX_FOLDER_DEPTH = 5;

export const FIXED_FOLDER_NAMES = [
  'Shared',
  'Chatbot',
  'Example folder',
  'Data',
  'Vector Memory',
  'Fluxbots',
  'Agents',
] as const;

export const RESERVED_FOLDER_NAMES = ['Shared', 'Default'] as const;

export const isFixedFolderName = (name: string): boolean => {
  const lower = name.trim().toLowerCase();
  return (FIXED_FOLDER_NAMES as readonly string[]).some(
    fixed => fixed.toLowerCase() === lower,
  );
};

export const isReservedFolderName = (name: string): boolean => {
  const lower = name.trim().toLowerCase();
  return (
    isFixedFolderName(name) ||
    (RESERVED_FOLDER_NAMES as readonly string[]).some(
      r => r.toLowerCase() === lower,
    )
  );
};

export const isFolderEmpty = (folder: Folder): boolean => {
  const hasFlows = (folder.flows?.length ?? 0) > 0;
  const hasSubfolders = (folder.folders?.length ?? 0) > 0;
  return !hasFlows && !hasSubfolders;
};

export const shouldAutoPruneWhenEmpty = (folder: Folder): boolean =>
  isFixedFolderName(folder.name) && isFolderEmpty(folder);
